import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useMap } from 'react-use';
import { useAnalyticsState } from 'analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';
import { InstrumentComparate } from './components/comparate/instrumentComparate';
import { InstrumentComparisonProvider } from './instrumentComparison.context';
import styles from './instrumentComparison.module.scss';
export const InstrumentComparison = ({ panel, }) => {
    var _a, _b, _c, _d;
    const { dashboard, context, period, settings } = useAnalyticsState();
    /**
     * A preselected context is one that cannot be changed i.e. not rendered as a
     * dropdown. For example when there is only one option available, or none at
     * all, or when the context is `hidden` but the values are `preselected`.
     *
     * In the case when the context is selectable, the second comparate receives
     * it as undefined initially, so the user has to select.
     */
    const hasPreselectedContext = ((_b = (_a = dashboard.context) === null || _a === void 0 ? void 0 : _a.values) !== null && _b !== void 0 ? _b : []).length <= 1 ||
        ((_d = (_c = dashboard.context) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.visualization) === 'hidden';
    // The list of comparates, i.e. things being compared to each other. The left side instrument data
    // is preloaded on mount. The right side instrument data is loaded on demand.
    const [comparates, { set: setComparate }] = useMap({
        left: {
            controls: {
                context,
                period,
                settings,
            },
        },
        right: {
            controls: {
                context: hasPreselectedContext ? context : undefined,
                period,
                settings,
            },
        },
    });
    return (_jsx(InstrumentComparisonProvider, Object.assign({ panel: panel }, { children: _jsxs("div", Object.assign({ className: styles.root }, { children: [_jsxs("div", Object.assign({ className: styles.columns }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "3", subdued: true }, { children: "Compare" })), _jsx(Text.Paragraph, Object.assign({ variant: "3", subdued: true }, { children: "With" }))] })), _jsx("div", Object.assign({ className: classnames(styles.columns, styles.columnsGrow) }, { children: Object.entries(comparates).map(([side, comparate]) => (_jsx(InstrumentComparate, { panel: panel, side: side, comparate: comparate, onUpdate: setComparate }, side))) }))] })) })));
};
